<template>

  <div class="app-container">

    <div>
      <el-button type="primary" size="small" @click="goback">返回</el-button>
    </div>
    <!-- 顶部栏 -->
    <div class="topbar" style="padding-top: 20px">
      <div>
        <!--        <el-input v-model="searchValue" size="mini" prefix-icon="el-icon-search" style="width: 400px"-->
        <!--                  @keyup.enter.native="search()"/>-->

        <!--        <el-button :disabled="!searchValue" type="primary" size="mini" icon="el-icon-search"-->
        <!--                   style="margin-left: 10px" @click="search()">-->
        <!--          搜索-->
        <!--        </el-button>-->

        <!--        <div style="padding-top: 20px;">-->
        <el-select style="padding-left: 20px;" clearable v-model="curRole" @change="curRoleChange">
          <el-option v-for="item in roleOptions" :key="item.value" :value="item.value"
                     :label="item.showText "></el-option>
        </el-select>

        <!--        </div>-->
        <br/>


      </div>

      <div>
        <el-button type="primary" size="small" @click="export2Excel">导出excel</el-button>
        <el-button type="primary" size="small" @click="go2LiveRecord()">前往往期回顾</el-button>
      </div>

    </div>
    <span style="color: red;padding: 20px;font-size: 14px;">*结束直播两分钟后才能看到完整录制视频数据</span>
    <p></p>
    <el-table v-loading="loading" :data="liveRecordVideoList" border stripe class="data-table"
              :header-cell-style="{ background: '#F5F7FA' }">
      <el-table-column label="#" prop="liveRecordVideoId" align="center"></el-table-column>
      <el-table-column label="成员信息" align="center">
        <template #default="props">
          <el-avatar :src="getCloudUrl(props.row.avatar)"></el-avatar>
          <br/>
          {{ getName(props.row) }}
        </template>

      </el-table-column>

      <el-table-column label="类型" prop="mediaId" align="center">
        <template #default="scope">{{ scope.row.mediaId | mediaIdTransform }}</template>
      </el-table-column>
      <el-table-column label="文件类型" prop="mediaId" align="center">
        <template #default="scope">{{ getVideoType(scope.row) }}</template>
      </el-table-column>
      <el-table-column label="开始录制时间" prop="startTimeStamp" align="center">
        <template #default="scope">
          {{ Number(scope.row.startTimeStamp.substring(0, 13)) | formatDateTime }}
        </template>
      </el-table-column>
      <el-table-column label="结束录制时间" prop="startTimeStamp" align="center">
        <template #default="scope">
          {{ Number(scope.row.endTimeStamp.substring(0, 13)) | formatDateTime }}
        </template>
      </el-table-column>
      <el-table-column label="删除时间" prop="startTimeStamp" align="center">
        <template #default="scope">
          {{ scope.row.deleteTime | formatDateTime }}
        </template>
      </el-table-column>

      <el-table-column label="操作" align="left" width="250">
        <template #default="scope">
          <el-link class="linkPadding" type="primary" size="small" @click="previewVideo(scope.row.videoUrl)">预览
          </el-link>
          <el-link class="linkPadding" type="primary" size="small" @click="downloadFile(scope.row.videoUrl)">下载
          </el-link>
          <!-- 0-未发布 1-已发布 -->

          <el-link class="linkPadding" size="small" link type="primary"
                   @click="handleDeleteLiveVideo(scope.row)">
            {{ scope.row.deleted ? '恢复' : '删除' }}
          </el-link>
          <el-link class="linkPadding" size="small" type="primary"
                   @click="handlePublicLiveVideo(scope.row)">
            {{ scope.row.publicStatus === 0 ? '发布' : '取消发布' }}
          </el-link>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination hide-on-single-page background :total="pageOpt.totalCount" :page-size="pageOpt.pageSize"
                   :current-page="pageOpt.currentPage" @current-change="currentPageChange"/>

    <!-- editReviewDialog -->
    <el-dialog title="发布视频" :visible.sync="editReviewDialog" width="60%"
               @close="editDlgClose" v-loading="dlgLoading">
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="视频标题" required>
          <el-input v-model="form.liveTitle"/>
        </el-form-item>
        <el-form-item label="视频描述">
          <el-input v-model="form.liveDescription" type="textarea"/>
        </el-form-item>
        <div style="overflow:auto;height: 60vh;">
          <el-form-item label="收费规则">
            <el-radio-group v-model="form.payStatus">
              <el-radio v-for="item in payOptions" :label="item.value">{{ item.name }}</el-radio>
            </el-radio-group>
            <el-input-number size="small" style="margin-left: 20px;" v-model="form.price"
                             v-if="form.payStatus === 1"></el-input-number>
          </el-form-item>
          <el-form-item label="直播科属">
            <el-select v-model="form.categoryId" style="width: 100%" filterable>
              <el-option v-for="item in categoryList" :key="item.forumCategoryId"
                         :label="item.categoryName" :value="item.forumCategoryId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所属领域">
            <el-select v-model="form.userDataType" style="width: 100%">
              <el-option v-for="item in userOptions" :key="item.value" :label="item.name"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="视频标签">
            <el-select v-model="form.liveVideoTabId" style="width: 100%" filterable>
              <el-option v-for="item in tabOptions" :key="item.liveVideoTabId"
                         :label="item.liveVideoTabTitle" :value="item.liveVideoTabId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="上传封面">
            <el-upload ref="uploadCoverRef" accept=".png,.jpg" action="" class="upload-demo" :limit="1"
                       :on-change="change2DisplayLocalImage" :auto-upload="false">
              <div style="text-align: left;">
                <el-image style="width: 100px; height: 100px"
                          :src="uploadCoverFileURL"
                          fit="scale-down">
                  <template #error>
                    <p></p>
                  </template>
                </el-image>
                <br/>
                <el-button size="small" type="primary">点击上传</el-button>
              </div>

              <div slot="tip" class="el-upload__tip">
                只能上传jpg/png文件
              </div>
            </el-upload>
          </el-form-item>
        </div>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="editReviewDialog = false">
          取 消
        </el-button>
        <el-button type="primary" size="small" @click="handlePublic()">
          确 定
        </el-button>
      </div>
    </el-dialog>
    <el-dialog title="预览视频" :visible.sync="previewVideoDialog" width="60%" height="80%" :destroy-on-close='true'>
      <!--      <video :src="getCloudUrl(videoSrc)" controls style="width: 100%;height: 60vh;overflow: auto;"/>-->
      <div>
        <tx-video-player style="height: 60vh" :videoUrl="videoSrc"></tx-video-player>
      </div>

    </el-dialog>
  </div>


</template>

<script>

import {
  isVaild
} from "@/utils/validate";

import {
  handleRes
} from "@/utils/handleRes";

import {
  liveRecordVideoPublic,
  liveRecordVideoUndo,
  getLiveRecordVideoList,
  liveRecordVideoDeleteOrBack
} from "@/api/mai/liveManagement/liveManagement";

import {
  getCategoryList,
  getTagList,
} from "@/api/mai/liveReviews/liveReviews";

import {
  getDisplayName
} from "@/utils/userutil";

import {
  getCloudUrl, getLocalFileURL
} from "@/utils/urlutil";

import {
  copy2Clipboard
} from "@/utils/clipboard";

import {
  getUserType
} from "@/utils/userutil";
import {deepClone} from "@/utils";
import {getOSSUploadInfo} from "@/api/system/CSDocument/file";
import {downloadFile, uploadFile2OSS} from "@/utils/OSSUpload";
import {printObj} from "@/utils/debug";
import txVideoPlayer from "@/components/TXVideoPlayer/txVideoPlayer";
import {export_json_to_excel} from "@/vendor/Export2Excel";

export default {
  name: "liveRecorder",
  components: {
    txVideoPlayer
  },
  data() {
    return {
      searchValue: "",
      loading: false,
      liveID: 0,
      // 分页配置
      pageOpt: {
        currentPage: 1,
        pageSize: 10,
        totalCount: 0,
      },
      //0-主持人和联席主持人端,1-嘉宾端,2-观众端（只有启动了合流录制才会有观众端视频）, 默认-1
      curRole: "",
      roleOptions:
          [
            {
              showText: '主持人和联席主持人端',
              value: 0
            },
            {
              showText: '嘉宾端',
              value: 1
            },
            {
              showText: '观众端',
              value: 2
            }
          ],
      liveRecordVideoList: [],
      //视频预览
      previewVideoDialog: false,
      videoSrc: "",
      //发布视频
      editReviewDialog: false,
      categoryList: [],
      form: {},
      tabOptions: [],
      payOptions: [
        {
          name: "免费",
          value: 0
        },
        {
          name: "付费",
          value: 1
        }
      ],
      userOptions: [],
      dlgLoading: false,
      uploadCoverFile: null,
      uploadCoverFileURL: null,
      curLiveRecordVideoEntity: null
    }
  },
  created() {
    this.liveID = this.$route.query.liveID
    this.refreshCurrentList()
    this.getCategoryList()
    this.getTabList()
    this.getUserType()
  },
  methods: {
    goback() {
      this.$router.go(-1)
    },
    search() {
      this.pageOpt.currentPage = 1;
      this.refreshCurrentList();
    },
    go2LiveRecord() {
      this.$router.push({
        name: "live_review_page",
      })
    },
    curRoleChange() {
      this.search()
    },
    currentPageChange(curPage) {
      this.pageOpt.currentPage = curPage
      this.refreshCurrentList()
    },
    refreshCurrentList() {
      this.getLiveRecordVideoList()
    },
    getCloudUrl(path) {
      return getCloudUrl(path)
    },
    getName(entity) {
      return getDisplayName(entity)
    },
    getVideoType(entity) {
      let url = entity.videoUrl
      return url.substring(url.lastIndexOf("."))
    },
    previewVideo(url) {
      this.previewVideoDialog = true;
      this.videoSrc = url;
    },
    downloadFile(url) {
      downloadFile(url)
    },
    handlePublicLiveVideo(entity) {
      if (entity.publicStatus === 0) {//
        // this.liveVideoRecordPublic(entity)
        this.form = {}
        this.curLiveRecordVideoEntity = entity;
        this.editReviewDialog = true;
      } else {
        this.liveVideoRecordUndo(entity)
      }
    },
    handleDeleteLiveVideo(entity) {
      this.liveRecordVideoDeleteOrBack(entity)
    },
    /**
     * 获取直播录制视频列表
     */
    getLiveRecordVideoList() {
      let params = {
        keyWord: this.searchValue,
        liveId: this.liveID,
        pageIndex: this.pageOpt.currentPage,
        pageSize: this.pageOpt.pageSize,
        role: this.curRole,
        sortName: "userId"
      };
      getLiveRecordVideoList(params).then((res) => {
            this.utils.stopLoading(this);
            handleRes(res, () => {
                  this.pageOpt.totalCount = res.data.total;
                  this.liveRecordVideoList = res.data.rows
                }
            );
          }
      )
    },
    async getAllLiveRecordVideoList() {
      let params = {
        keyWord: this.searchValue,
        liveId: this.liveID,
        pageIndex: 1,
        pageSize: 0,
        role: this.curRole,
        sortName: "userId"
      };
      return await getLiveRecordVideoList(params)
    },
    /**
     * 发布视频录制
     * @param params
     */
    async liveVideoRecordPublic(params) {
      this.dlgLoading = true;
      //传封面
      let savepathParamsRes = await getOSSUploadInfo({
        DataType: "10",
        ID: "0",
      });
      if (!isVaild(savepathParamsRes)) {
        return;
      }
      let savePathParams = savepathParamsRes.resultData
      //上传封面
      if (isVaild(this.uploadCoverFile)) {
        // printObj(this.uploadCoverFile.raw)
        let timestamp = new Date().valueOf();

        let uploadRes;
        let fileName;
        if (isVaild(this.uploadCoverFile)) {
          fileName = savePathParams.PicSavePath + timestamp + this.uploadCoverFile.name.substring(this.uploadCoverFile.name.lastIndexOf("."));
          // console.log("upload info " + savePathParams.PicSavePath + " " + fileName)
          uploadRes = await uploadFile2OSS(savePathParams, new Blob([this.uploadCoverFile.raw], {
            type: this.uploadCoverFile.raw.type
          }), fileName)
        }
        if (uploadRes.status === 0) {
          params.liveCover = this.config.RESOURCES + "/" + fileName
          // console.log(this.form.liveCover)
        } else {
          this.$message({
            type: "error",
            message: "上传失败"
          })
        }
        this.$refs.uploadCoverRef.clearFiles();
      }
      //发布
      // printObj(params)
      liveRecordVideoPublic(params).then((res) => {
        this.dlgLoading = false;
        handleRes(res, () => {
          this.editReviewDialog = false
          this.refreshCurrentList()
        })
      })
    },
    /**
     * 撤销发布视频录制
     * @param entity
     */
    liveVideoRecordUndo(entity) {
      liveRecordVideoUndo({
        liveRecordVideoId: entity.liveRecordVideoId
      }).then((res) => {
        handleRes(res, () => {
          this.refreshCurrentList()
        })
      })
    },
    /**
     * 删除/录制录制视频
     * @param entity
     */
    liveRecordVideoDeleteOrBack(entity) {
      liveRecordVideoDeleteOrBack({
        liveRecordVideoId: entity.liveRecordVideoId
      }).then((res) => {
        handleRes(res, () => {
          this.refreshCurrentList()
        })
      })
    },
    getCategoryList() {
      getCategoryList().then((res) => {
        handleRes(res, () => {
          this.categoryList = res.data
        })
      });
    },
    getTabList() {
      getTagList({
        pageSize: 0
      }).then((res) => {
        handleRes(res, () => {
          this.tabOptions = res.data.rows
        })
      })
    },
    getUserType() {
      this.userOptions = getUserType();
    },
    change2DisplayLocalImage(uploadFile) {
      this.$refs.uploadCoverRef.clearFiles();
      this.uploadCoverFile = uploadFile;
      this.uploadCoverFileURL = getLocalFileURL(uploadFile);
    },
    handlePublic() {

      let params = deepClone(this.form);
      params.pushFlowUrl = this.curLiveRecordVideoEntity.videoUrl
      params.liveRecordVideoId = this.curLiveRecordVideoEntity.liveRecordVideoId

      this.liveVideoRecordPublic(params)
    },
    editDlgClose() {
      this.uploadCoverFile = null
      this.uploadCoverFileURL = ""
      this.curLiveRecordVideoEntity = null
    },
    async export2Excel() {
      if (this.liveRecordVideoList.length === 0) {
        this.$message.info('没有要导出数据')
        return;
      }
      let {
        tName,
        tHeader,
        filterValue
      } = this.getExcelInfo()
      let res = await this.getAllLiveRecordVideoList()
      let list = this.formatTableData(res.data.rows)
      let data = this.formatJson(filterValue, list)
      export_json_to_excel({
        header: tHeader,
        data,
        filename: tName,
        autoWidth: true,
        bookType: "xlsx",
      })
    },
    getExcelInfo() {
      let tName = '录制视频记录';
      let tHeader;
      let filterValue;
      tHeader = ['视频ID', '成员', '用户ID', '视频地址', '开始录制时间', '结束录制时间',]
      filterValue = [
        'liveRecordVideoId',
        'nickname',
        'userId',
        'videoUrl',
        'startTimeStamp',
        'endTimeStamp',
      ]
      return {
        tName,
        tHeader,
        filterValue
      }
    },
    formatTableData(list) {
      let newList = list.map(item => {
        item.nickname = getDisplayName(item)
        item.startTimeStamp = this.$options.filters["formatDateTime"](Number(item.startTimeStamp.substring(0, 13)))
        item.endTimeStamp = this.$options.filters["formatDateTime"](Number(item.endTimeStamp.substring(0, 13)))
        return item
      })

      return newList
    },
    /**
     * 格式化 JSON
     *
     * @param filterValue
     * @param jsonData
     */
    formatJson(filterValue, jsonData) {
      return jsonData.map(x => filterValue.map(y => {
        return x[y]
      }))
    },
  },
}
</script>

<style scoped>
.linkPadding {
  /*padding-left: 20px;*/
  margin-right: 10px;
}
</style>